var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myAccount" },
    [
      _c("div", { staticClass: "topbar" }, [
        _c("i", { on: { click: _vm.goHome } }),
        _vm._v(" "),
        _c("div", { staticClass: "mainBox1" }, [
          _c(
            "div",
            {
              staticClass: "changeLangBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.moreLang()
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.$t("language")) + "\n        "),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.changeLangBox,
                      expression: "changeLangBox"
                    }
                  ],
                  staticClass: "chooseLangUl"
                },
                _vm._l(_vm.langList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "chooseLangUlli",
                      on: {
                        click: function($event) {
                          _vm.setLanguage(item.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.name) + "\n          "
                      )
                    ]
                  )
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "settingBtn",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.setting()
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("myaccount_title")) + "\n        "
              ),
              _c("em", { staticClass: "iconfont icon-een" }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.settingBoxVis,
                      expression: "settingBoxVis"
                    }
                  ],
                  staticClass: "chooseLangUl chooseLangUls"
                },
                [
                  _c("li", { on: { click: _vm.goHome } }, [
                    _vm._v(_vm._s(_vm.$t("myHome")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.race } }, [
                    _vm._v(_vm._s(_vm.$t("myPageTitle")))
                  ]),
                  _vm._v(" "),
                  _c("li", { on: { click: _vm.logOut } }, [
                    _vm._v(_vm._s(_vm.$t("setting_2")))
                  ])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "banner" }, [
        _c("div", { staticClass: "forget" }, [
          _c("div", { staticClass: "Title" }, [
            _vm._v(_vm._s(_vm.$t("myaccount_title")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputItem btns" }, [
            _c("div", { staticClass: "avatorBox" }, [
              _c("img", {
                attrs: { src: _vm.userAvator.url, width: "120", height: "120" }
              })
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "MAbtn",
                on: {
                  click: function($event) {
                    ;(_vm.modifyAvatorShow = true), _vm.getAvator()
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("modify_avator")))])]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputItem clearfix" }, [
            _c("span", { staticClass: "account" }, [
              _vm._v(_vm._s(_vm.$t("signup_txt2")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.temp.name,
                  expression: "temp.name",
                  modifiers: { trim: true }
                }
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.temp.name },
              on: {
                blur: [
                  _vm.checkName,
                  function($event) {
                    _vm.$forceUpdate()
                  }
                ],
                focus: _vm.checkName1,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.temp, "name", $event.target.value.trim())
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show2,
                    expression: "show2"
                  }
                ],
                staticClass: "s1"
              },
              [_vm._v(_vm._s(_vm.$t("signup_note8")))]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "inputItem schoolItem clearfix" },
            [
              _c(
                "span",
                { staticClass: "account", staticStyle: { zIndex: "120" } },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("schoolName")) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "classGrade",
                  attrs: {
                    "filter-method": _vm.changeSchoolFilter,
                    filterable: "",
                    remote: ""
                  },
                  on: { change: _vm.changeSchool },
                  model: {
                    value: _vm.temp.schoolName,
                    callback: function($$v) {
                      _vm.$set(_vm.temp, "schoolName", $$v)
                    },
                    expression: "temp.schoolName"
                  }
                },
                _vm._l(_vm.schoolList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.schoolCnName, value: item.id }
                  })
                })
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show10,
                      expression: "show10"
                    }
                  ],
                  staticClass: "s1"
                },
                [_vm._v(_vm._s(_vm.$t("signup_note9")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "inputItem clearfix" }, [
            _c(
              "span",
              {
                staticClass: "account",
                staticStyle: { "margin-right": "20px" }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("signup_txt3")) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "classGrade",
                staticStyle: { paddingLeft: "159px" }
              },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.grade,
                        expression: "temp.grade"
                      }
                    ],
                    staticClass: "input11",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.temp,
                            "grade",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.checkGrade
                      ]
                    }
                  },
                  [
                    _c(
                      "option",
                      {
                        staticStyle: { display: "none" },
                        attrs: { value: "" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("signup_note9")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v(_vm._s(_vm.$t("grade0")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(_vm._s(_vm.$t("grade1")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v(_vm._s(_vm.$t("grade2")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [
                      _vm._v(_vm._s(_vm.$t("grade3")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "4" } }, [
                      _vm._v(_vm._s(_vm.$t("grade4")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "5" } }, [
                      _vm._v(_vm._s(_vm.$t("grade5")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "6" } }, [
                      _vm._v(_vm._s(_vm.$t("grade6")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "7" } }, [
                      _vm._v(_vm._s(_vm.$t("grade7")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "8" } }, [
                      _vm._v(_vm._s(_vm.$t("grade8")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "9" } }, [
                      _vm._v(_vm._s(_vm.$t("grade9")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "10" } }, [
                      _vm._v(_vm._s(_vm.$t("grade10")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "11" } }, [
                      _vm._v(_vm._s(_vm.$t("grade11")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "12" } }, [
                      _vm._v(_vm._s(_vm.$t("grade12")))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "13" } }, [
                      _vm._v(_vm._s(_vm.$t("grade13")))
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show9,
                    expression: "show9"
                  }
                ],
                staticClass: "s1"
              },
              [_vm._v(_vm._s(_vm.$t("signup_note9")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "inputItem clearfix" }, [
            _c("span", { staticClass: "account" }, [
              _vm._v(_vm._s(_vm.$t("signup_txt12")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.temp.email,
                  expression: "temp.email",
                  modifiers: { trim: true }
                }
              ],
              staticStyle: {
                cursor: "not-allowed",
                background: "rgba(277,277,277,.85)"
              },
              attrs: { type: "text", disabled: "" },
              domProps: { value: _vm.temp.email },
              on: {
                blur: [
                  _vm.checkEmail,
                  function($event) {
                    _vm.$forceUpdate()
                  }
                ],
                focus: _vm.checkEmail1,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.temp, "email", $event.target.value.trim())
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show8,
                    expression: "show8"
                  }
                ],
                staticClass: "s1"
              },
              [_vm._v(_vm._s(_vm.$t("signup_note16")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btns" }, [
            _c(
              "button",
              {
                staticClass: "MAbtn",
                on: {
                  click: function($event) {
                    _vm.modifyPsdShow = true
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("modifyPwd_button")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("button", { staticClass: "MAbtn", on: { click: _vm.sucess } }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("myaccount_button")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.allMsg,
                expression: "allMsg"
              }
            ],
            staticClass: "send",
            domProps: { textContent: _vm._s(_vm.warinningText) }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "modify_dialog",
          attrs: {
            visible: _vm.modifyPsdShow,
            "show-close": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.modifyPsdShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "container-box" }, [
              _c("div", {
                staticClass: "closebtn",
                on: {
                  click: function($event) {
                    _vm.modifyPsdShow = false
                  }
                }
              }),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.$t("modifyPwd_button")))]),
              _vm._v(" "),
              _c("div", { staticClass: "detailBox detailBoxInput" }, [
                _c(
                  "section",
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "detailBox-input",
                        attrs: {
                          placeholder: this.$t("modifyPsd_1"),
                          type: _vm.showPsd1 === false ? "password" : "text"
                        },
                        model: {
                          value: _vm.modify_input.ori,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modify_input,
                              "ori",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modify_input.ori"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-view el-input__icon",
                          attrs: { slot: "suffix" },
                          on: {
                            click: function($event) {
                              _vm.showPsd1 = !_vm.showPsd1
                            }
                          },
                          slot: "suffix"
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "detailBox-input",
                        attrs: {
                          placeholder: this.$t("modifyPsd_2"),
                          type: _vm.showPsd2 === false ? "password" : "text"
                        },
                        model: {
                          value: _vm.modify_input.new,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modify_input,
                              "new",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modify_input.new"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-view el-input__icon",
                          attrs: { slot: "suffix" },
                          on: {
                            click: function($event) {
                              _vm.showPsd2 = !_vm.showPsd2
                            }
                          },
                          slot: "suffix"
                        })
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "detailBox-input",
                        attrs: {
                          placeholder: this.$t("modifyPsd_3"),
                          type: _vm.showPsd3 === false ? "password" : "text"
                        },
                        model: {
                          value: _vm.modify_input.newA,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modify_input,
                              "newA",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "modify_input.newA"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-view el-input__icon",
                          attrs: { slot: "suffix" },
                          on: {
                            click: function($event) {
                              _vm.showPsd3 = !_vm.showPsd3
                            }
                          },
                          slot: "suffix"
                        })
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modifybtns" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.modifyPsdShow = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("com_cancel")) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn", on: { click: _vm.updatePassword } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("com_confirm")) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "modify_dialog",
          attrs: {
            visible: _vm.modifyAvatorShow,
            "show-close": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.modifyAvatorShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("i", {
              staticClass: "closebtn",
              on: {
                click: function($event) {
                  _vm.modifyAvatorShow = false
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "container-box" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$t("modify_Avator")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detailBox detailBoxImg" },
                _vm._l(_vm.avatorList, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "imgCover",
                      class: {
                        selected: _vm.avatorSelect.url == item.url,
                        coverLock: item.usable == 0
                      }
                    },
                    [
                      _c("div", { staticClass: "tag" }, [
                        _c("span", [_vm._v(_vm._s(item.picExplain))])
                      ]),
                      _vm._v(" "),
                      item.usable == 0
                        ? _c("i", { staticClass: "locked" })
                        : _vm._e(),
                      _vm._v(" "),
                      item.usable == 0
                        ? _c("i", { staticClass: "lockIcon" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("img", {
                        attrs: { src: item.url, width: "120", height: "120" },
                        on: {
                          click: function($event) {
                            _vm.setImg(item.id, item.url)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.avatorSelect.url == item.url
                        ? _c("i", { staticClass: "coner coner-lt" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.avatorSelect.url == item.url
                        ? _c("i", { staticClass: "coner coner-rt" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.avatorSelect.url == item.url
                        ? _c("i", { staticClass: "coner coner-rb" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.avatorSelect.url == item.url
                        ? _c("i", { staticClass: "coner coner-lb" })
                        : _vm._e()
                    ]
                  )
                })
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modifybtns" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.modifyAvatorShow = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("com_cancel")) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn", on: { click: _vm.updateAvator } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("com_confirm")) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("LEAPPOPUP", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.maskBox,
            expression: "maskBox"
          }
        ],
        attrs: {
          title: _vm.$t("timeout01"),
          content: _vm.$t("timeout02"),
          cancelButtonTxt: _vm.$t("timeout04"),
          okButtonTxt: _vm.$t("timeout03"),
          isConfirm: false
        },
        on: { onOK: _vm.logOut }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c670a81", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c670a81","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myAccount.vue
// module id = null
// module chunks = 